import { get } from "svelte/store";
import * as turf from "@turf/turf";
export class MatrixMapManager {
    constructor(matrixRowManager, matrixManager) {
        this.matrixRowManager = matrixRowManager;
        this.matrixManager = matrixManager;
        this.sourceId = `locations-${get(matrixRowManager.id)}`;
        this.layerId = `locations-${get(matrixRowManager.id)}`;
        const locations = get(matrixManager.locations);
        this.onLocationsChanged(locations);
        matrixManager.locations.subscribe(ls => {
            this.onLocationsChanged(ls);
        });
        const visible = get(matrixRowManager.visible);
        this.onVisibleChanged(visible);
        this.matrixRowManager.visible.subscribe(v => {
            this.onVisibleChanged(v);
        });
    }
    addToMap(map) {
        this.map = map;
        this.onLocationsChanged(get(this.matrixManager.locations));
    }
    onLocationsChanged(locations) {
        if (typeof this.map === "undefined")
            return;
        this.createLayers();
        const features = [];
        const id = get(this.matrixRowManager.id);
        locations.forEach((l, i) => {
            features.push(turf.point([l.longitude, l.latitude], {
                id: i,
                name: i,
                "matrix_id": id,
                type: "location",
                location_type: l.properties?.type ?? "unknown"
            }));
        });
        const source = this.map.addOrGetSource(this.sourceId, {
            type: "geojson",
            data: turf.featureCollection([])
        });
        source.setData(turf.featureCollection(features));
    }
    onVisibleChanged(visible) {
        if (typeof this.map === "undefined")
            return;
        this.createLayers();
        this.map.setLayoutProperty(`${this.layerId}-back`, "visibility", visible ? "visible" : "none");
        this.map.setLayoutProperty(this.layerId, "visibility", visible ? "visible" : "none");
        this.map.setLayoutProperty(`${this.layerId}-poi-back`, "visibility", visible ? "visible" : "none");
        this.map.setLayoutProperty(`${this.layerId}-poi`, "visibility", visible ? "visible" : "none");
    }
    createLayers() {
        if (typeof this.map === "undefined")
            return;
        if (this.map.hasLayer(this.layerId))
            return;
        const source = this.map.addOrGetSource(this.sourceId, {
            type: "geojson",
            data: turf.featureCollection([])
        });
        const visible = get(this.matrixRowManager.visible);
        // Minimum needed zoom for the smaller points of the matrix
        const minZoom = 14.5;
        // Minimum needed zoom for the centerpoint of the matrix
        const minZoomPoi = 0;
        this.map.addLayer({
            id: `${this.layerId}-back`,
            type: "circle",
            source: this.sourceId,
            minzoom: minZoom,
            layout: {
                visibility: visible ? "visible" : "none",
            },
            paint: {
                "circle-color": "#000000",
                "circle-radius": 4,
            },
            filter: ["!=", "location_type", "point-of-interest"]
        });
        this.map.addLayer({
            id: this.layerId,
            type: "circle",
            source: this.sourceId,
            minzoom: minZoom,
            layout: {
                visibility: visible ? "visible" : "none",
            },
            paint: {
                "circle-color": "#FFF",
                "circle-stroke-width": 0,
                "circle-radius": 3,
            },
            filter: ["!=", "location_type", "point-of-interest"]
        });
        this.map.addLayer({
            id: `${this.layerId}-poi-back`,
            type: "circle",
            source: this.sourceId,
            minzoom: minZoomPoi,
            layout: {
                visibility: visible ? "visible" : "none",
            },
            paint: {
                "circle-color": "#000000",
                "circle-radius": 7,
            },
            filter: ["==", "location_type", "point-of-interest"]
        });
        this.map.addLayer({
            id: `${this.layerId}-poi`,
            type: "circle",
            source: this.sourceId,
            minzoom: minZoomPoi,
            layout: {
                visibility: visible ? "visible" : "none",
            },
            paint: {
                "circle-color": "#FFF",
                "circle-stroke-width": 0,
                "circle-radius": 5,
            },
            filter: ["==", "location_type", "point-of-interest"]
        });
    }
    remove() {
        if (typeof this.map === "undefined")
            return;
        if (this.map.hasLayer(`${this.layerId}-back`))
            this.map.removeLayer(`${this.layerId}-back`);
        if (this.map.hasLayer(`${this.layerId}`))
            this.map.removeLayer(`${this.layerId}`);
        if (this.map.hasLayer(`${this.layerId}-poi`))
            this.map.removeLayer(`${this.layerId}-poi`);
        if (this.map.hasLayer(`${this.layerId}-poi-back`))
            this.map.removeLayer(`${this.layerId}-poi-back`);
        if (this.map.hasSource(this.sourceId))
            this.map.removeSource(this.sourceId);
    }
}
